import {
  EnvelopeIcon,
  GlobeAltIcon,
  PhoneIcon,
} from '@heroicons/react/24/outline';

import { HANDLE_TYPES } from './types';

interface ChannelTypeSelectorEnhancedProps {
  value: string;
  onChange: (value: string) => void;
}

const getIcon = (type: string) => {
  switch (type) {
    case 'WEBSITE':
      return GlobeAltIcon;
    case 'MAILING_ADDRESS':
    case 'EMAIL':
      return EnvelopeIcon;
    case 'PHONE':
    case 'FAX':
      return PhoneIcon;
    default:
      return GlobeAltIcon;
  }
};

export const ChannelTypeSelectorEnhanced = ({
  value,
  onChange,
}: ChannelTypeSelectorEnhancedProps) => {
  return (
    <div className="space-y-3">
      <div className="text-center">
        <h3 className="text-lg font-semibold text-gray-900">
          How can records be requested?
        </h3>
        <p className="mt-1 text-sm text-gray-500">
          Choose the primary contact method for this channel
        </p>
      </div>

      <div className="grid grid-cols-2 gap-3">
        {HANDLE_TYPES.map((type) => {
          const Icon = getIcon(type.value);
          const isSelected = value === type.value;
          return (
            <button
              key={type.value}
              type="button"
              onClick={() => onChange(type.value)}
              className={`group flex flex-col items-center gap-3 rounded-xl border-2 p-6 text-center transition-all hover:shadow-md ${
                isSelected
                  ? 'border-blue-500 bg-blue-50 shadow-sm'
                  : 'border-gray-200 hover:border-gray-300'
              }`}
            >
              <div
                className={`rounded-lg p-3 transition-colors ${
                  isSelected
                    ? 'bg-blue-100'
                    : 'bg-gray-100 group-hover:bg-gray-200'
                }`}
              >
                <Icon
                  className={`h-6 w-6 ${isSelected ? 'text-blue-600' : 'text-gray-600'}`}
                />
              </div>
              <div>
                <div
                  className={`text-sm font-semibold ${
                    isSelected ? 'text-blue-900' : 'text-gray-900'
                  }`}
                >
                  {type.label}
                </div>
                <p
                  className={`mt-1 text-xs ${
                    isSelected ? 'text-blue-700' : 'text-gray-500'
                  }`}
                >
                  {type.description}
                </p>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};
